import {createSelector} from 'reselect';

import {selectDeviceData, selectHolderData} from '@/state/selectors/device';

const selectDeviceSettings = createSelector(selectDeviceData, selectHolderData, (deviceData, holderData) => {
    //holder settings should be first so device settings can redefine holder settings
    if (deviceData && holderData) return {...holderData, ...deviceData};

    if (deviceData) return deviceData;

    return holderData;
});

const selectFlexPuff = createSelector(selectDeviceSettings, (settings) => settings?.engineJoule?.featureState);
const selectAutoStart = createSelector(selectDeviceSettings, (settings) => settings?.autoStartHeating?.featureState);
const selectLedIntensity = createSelector(selectDeviceSettings, (settings) => settings?.ledIntensity?.intensity);
const selectDeviceLockStatus = createSelector(
    selectDeviceSettings,
    (settings) => settings?.parentProtection?.protectionType
);

export {selectAutoStart, selectDeviceLockStatus, selectDeviceSettings, selectFlexPuff, selectLedIntensity};
